import io from 'socket.io-client';
import {settings, currentConfig} from '../config/config'

export default class SingletonClass {
    static _instance = new SingletonClass()
    _connected
    // _socket = settings.enableSocket ? undefined : {on(){}}
    _socket=undefined

    constructor() {

        // Parse a given querystring
        const qs = new URLSearchParams(location.search)
        const ss = qs.get("ss") ? qs.get('ss') : settings[currentConfig].socketServer
        const p = qs.get('p') ? parseInt(qs.get('p')) : settings.socketPort

        SingletonClass._instance = this
        if(!settings.enableSocket) {
            console.log('do not need a socket')
            return
        }
        this._connected = false
        console.log('load socket config success: ', settings[currentConfig].socketServer, settings.socketPort)
        const socket = io(ss + ':' + p)
        const _connectTimer = setTimeout(() => {
            console.log('cannot connect')
            socket.close()
        }, 5000);
        socket.on('connect', () => {
            this._connected = true
            clearTimeout(_connectTimer)
            console.log('connected')
        })
        this._socket = socket
    }

    emit(evt, data = {}) {
        if (this._connected && this._socket) {
            this._socket.emit(evt, data)
        } else {
            console.log('socket not connected')
        }
    }
    getSocket() {
        return this._socket
    }
    static getInstance() {
        return SingletonClass._instance
    }
}